module.exports = __webpack_public_path__ + "img/one.8ae6010c.svg";